import React, { useState, useEffect } from 'react';
import InnovationCard from '../InnovationCard/InnovationCard';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";


const InnovationMain = () => {
    const [innoContent, setInnoContent] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.innovationProgram,
            })
            .then((response) => {
                const innovationContent = response.data.allInnoprograms.edges[0].node;
                setInnoContent(innovationContent);


            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (

        <div className="row pt-5">
            <div className="col-md-5">
                <div>
                    {/* <h5 className="section-title d-block d-md-none">INNOVATION</h5> */}
                    <h1 className="subtitle ">{innoContent?.title[0]?.text}</h1>
                    <ul>
                        {innoContent?.description_para?.map((info,index) => <li key={index+1} className=" py-2  body-text">{info.para1}</li>)}
                    </ul>


                    <a target="_blank" href={innoContent?.apply_link} className="text-decoration-none pb-3   d-flex justify-content-start">
                        <button className="primary-btn     ">{innoContent?.apply_text}</button>
                    </a>
                </div>
            </div>
            <div className="col-md-7 ">

                <div className="row  g-2  " >
                    {innoContent?.innovation_info?.map(innovationInfo =>
                        <InnovationCard
                            key={Date.now() + Math.random()}
                            Info={innovationInfo}
                            showImg={true}
                        >

                        </InnovationCard>)
                    }

                </div>
            </div>
        </div>



    );
};

export default InnovationMain;